
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contests/airmiles-giveaway",
      function () {
        return require("private-next-pages/contests/airmiles-giveaway.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contests/airmiles-giveaway"])
      });
    }
  